import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { useDispatch } from "react-redux";
import { putLike } from "../../features/video/videoSlice";
import { useParams } from "react-router-dom";
import { putUnLike } from "./../../features/video/videoSlice";

export default function LikeUnlike({ likes, unlikes }) {
    const dispatch = useDispatch();

    const { videoId } = useParams();
    const likeHandler = () => {
        dispatch(
            putLike({
                id: videoId,
                likes: likes + 1,
            })
        );
    };
    const unLikeHandler = () =>
        dispatch(
            putUnLike({
                id: videoId,
                unlikes: unlikes + 1,
            })
        );
    {
    }

    return (
        <div className="flex gap-10 w-48">
            <button onClick={likeHandler}>
                <div className="flex gap-1">
                    <div className="shrink-0">
                        <img className="w-5 block" src={likeImage} alt="Like" />
                    </div>
                    <div className="text-sm leading-[1.7142857] text-slate-600">
                        {likes}
                    </div>
                </div>
            </button>
            <button onClick={unLikeHandler}>
                <div className="flex gap-1">
                    <div className="shrink-0">
                        <img
                            className="w-5 block"
                            src={unlikeImage}
                            alt="Unlike"
                        />
                    </div>
                    <div className="text-sm leading-[1.7142857] text-slate-600">
                        {unlikes}
                    </div>
                </div>
            </button>
        </div>
    );
}
